import { gql } from '@apollo/client';

const Fragments = {
  userGroup: gql`
    fragment userGroup on UserGroupType {
      id
      code
      name
      email
      isAdmin
      appCodes
    }
  `
};

export default Fragments;
